<div class="checkout-wrapper">
  <div class="container">

    <div class="header-checkout">
      <h1 class="fadeInDown" appVisibility>Selecciona tu Paquete</h1>
      <p class="fadeInUp" appVisibility>Estás a un paso de optimizar tu logística.</p>
    </div>

    <div class="layout-grid">

      <div class="selector-panel">

        <div class="tabs-list fadeIn" appVisibility>
          <button *ngFor="let tab of tabs" class="tab-btn" [class.active]="activeTab === tab.id"
            (click)="filterByTab(tab.id)">
            {{ tab.label }}
          </button>
        </div>

        <div class="cards-container" *ngIf="!loading">

          <div class="pkg-card fadeInUp" appVisibility *ngFor="let pkg of filteredPackages"
            [class.selected]="selectedPackage?.id === pkg.id" (click)="selectPackage(pkg)">

            <div class="pkg-radio"></div>

            <div class="pkg-main">

              <h3>{{ pkg.nombre }}</h3>
              <div class="pkg-qty">
                <span class="icon">📦</span> {{ pkg.numGuias }} Guías <span class="weight-badge">{{ pkg.descripcion1
                  }}</span>
              </div>
            </div>

            <div class="pkg-pricing">
              <span class="price">{{ formatMoney(pkg.costo) }}</span>
              <span class="tax-info">IVA Incluido</span>
            </div>

          </div>

        </div>

        <div class="loading-state" *ngIf="loading">
          <div class="spinner"></div> Cargando paquetes...
        </div>

      </div>

      <div class="summary-panel" id="checkout-summary">
        <div class="summary-card fadeInUp" appVisibility>

          <div class="card-title">Resumen de Compra</div>

          <div *ngIf="selectedPackage; else emptyState">

            <div class="summary-row main-row">
              <span>Paquete:</span>
              <strong>{{ selectedPackage.nombre }}</strong>
            </div>
            <div class="summary-row">
              <span>Cantidad:</span>
              <span>{{ selectedPackage.numGuias }} Guías</span>
            </div>

            <div class="summary-row">
              <span>Peso Máx:</span>
              <span>{{ selectedPackage.descripcion1 }}</span>
            </div>

            <hr class="divider">

            <div class="benefits-list">
              <p class="benefits-title">Detalles del servicio:</p>

              <div *ngIf="loadingDetail" class="mini-loader">Cargando detalles...</div>

              <ul *ngIf="!loadingDetail && selectedPackageDetail">
                <li *ngFor="let ben of selectedPackageDetail.beneficios">
                  <span class="check">✓</span> {{ ben }}
                </li>
              </ul>
              <ul *ngIf="!loadingDetail && !selectedPackageDetail">
                <li><span class="check">✓</span> Vigencia 1 Año</li>
                <li><span class="check">✓</span> Cobertura Nacional</li>
              </ul>
            </div>

            <!-- Aviso Franja Fronteriza -->
            <div class="disclaimer-text">
              <span class="material-symbols-outlined warning-icon">warning</span>
              <span>
                Todo envío con origen en zona fronteriza deberá presentar factura fiscal del producto antes de su
                traslado. En caso de no contar con documentación válida, el paquete no será recibido ni enviado, conforme
                a disposiciones del SAT. La empresa no se hace responsable por retrasos o retenciones derivadas del
                incumplimiento.
              </span>
            </div>

            <div class="total-block">
              <div class="total-label">Total a Pagar</div>
              <div class="total-amount">{{ formatMoney(selectedPackage.costo) }}</div>
            </div>

            <button class="btn-pay" (click)="comprar()">
              {{ isLoguedin ? 'Pagar Ahora' : 'Inicia Sesión para Pagar' }}
              <span class="material-symbols-outlined">arrow_forward</span>
            </button>

            <div class="security-seal">
              🔒 Pago Seguro SSL
            </div>

          </div>

          <ng-template #emptyState>
            <div class="empty-msg">
              Selecciona un paquete de la izquierda para ver el desglose.
            </div>
          </ng-template>

        </div>
      </div>

    </div>



  </div>
</div>